export const CND_URL='https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/'

export const LOGO_URL="https://www.logodesign.net/logo/smoking-burger-with-lettuce-3624ld.png?size=large"

export const Menu="https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=28.6224262&lng=77.0434934&restaurantId=";